import { schema } from "normalizr";
import { SCHOOL_SCHEMA } from "./index";

export default new schema.Entity(SCHOOL_SCHEMA);
